import NumberFormat from 'react-number-format';

interface RefProps {
    inputElement: any
};

/**
 * Wrapper for `NumberFormat` that integrates with `TextField` component.
 * @param props The object with the props for `NumberFormat`
 */
export const NumberFormatField = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            ref={(ref: RefProps) => { inputRef(ref ? ref.inputElement : null); }}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
        />
    );
}